/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ForecasterPremiumOnboardingCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ForecasterPremiumOnboardingCardQuery = { __typename: 'Query', premiumOnboardingOption?: { __typename: 'PremiumOnboardingOption', hasScheduledMeeting: boolean, fee: number, feeDisclosure: string } | null };


export const ForecasterPremiumOnboardingCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForecasterPremiumOnboardingCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premiumOnboardingOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasScheduledMeeting"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeDisclosure"}}]}}]}}]} as unknown as DocumentNode<ForecasterPremiumOnboardingCardQuery, ForecasterPremiumOnboardingCardQueryVariables>;